<template>
<div class="col-md-12 stock-form">
  <div class="card">
    <form>
      <div class="card-header">
        <h4 class="card-title">
          {{ title }}
        </h4>
      </div>
      <div class="card-content">
        <div class="row form-group">
          <div class="col-md-4">
            <label>Evento</label>
            <div>
              <el-select
                filterable
                size="xlarge"
                class="select-primary"
                placeholder="Selecione um evento"
                v-model="model.eventId"
                name="eventId"
                v-validate="modelValidations.eventId"
              >
                <el-option
                  v-for="option in events"
                  class="select-primary"
                  :value="option._id"
                  :label="`${option.city} - ${option.reference}`"
                  :key="option._id"
                >
                </el-option>
              </el-select>
            </div>
            <small
              class="text-danger"
              v-show="eventId.invalid"
            >
              {{ getError('eventId') }}
            </small>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <label>Fabricante</label>
            <div>
              <el-select
                filterable
                class="select-primary"
                size="large"
                placeholder="Selecione um fabricante"
                v-model="model.manufacturerId"
                name="manufacturerId"
                v-validate="modelValidations.manufacturerId"
              >
                <el-option
                  v-for="option in manufacturers"
                  class="select-primary"
                  :value="option._id"
                  :label="option.name"
                  :key="option._id"
                >
                </el-option>
              </el-select>
            </div>
            <small
              class="text-danger"
              v-show="manufacturerId.invalid"
            >
              {{ getError('manufacturerId') }}
            </small>
          </div>
        </div>
        <div class="form-group">
          <label>Nº referencia nota fiscal fabricante</label>
          <input
            type="number"
            name="invoice"
            v-validate="modelValidations.invoice"
            v-model="model.invoice"
            class="form-control"
          >
          <small
            class="text-danger"
            v-show="invoice.invalid"
          >
            {{ getError('invoice') }}
          </small>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Data de emissão da nota fiscal do fabricante</label>
            <div>
              <el-date-picker
                name="dateInvoice"
                v-validate="modelValidations.dateInvoice"
                v-model="model.dateInvoice"
                type="date"
                placeholder="Escolha uma data"
                format="dd/MM/yyyy"
                :clearable="false"
                :editable="false"
              ></el-date-picker>
            </div>
            <small
              class="text-danger"
              v-show="dateInvoice.invalid"
            >
              {{ getError('dateInvoice') }}
            </small>
          </div>
        </div>
        <div class="form-group">
          <label>Nº referencia nota fiscal da concessionária</label>
          <input
            type="number"
            name="invoicePowerCompany"
            v-validate="modelValidations.invoicePowerCompany"
            v-model="model.invoicePowerCompany"
            class="form-control"
          >
          <small
            class="text-danger"
            v-show="invoicePowerCompany.invalid"
          >
            {{ getError('invoicePowerCompany') }}
          </small>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Data de Emissão da Nota Fiscal da Concessionaria</label>
            <div>
              <el-date-picker
                name="dateInvoicePowerCompany"
                v-validate="modelValidations.dateInvoicePowerCompany"
                v-model="model.dateInvoicePowerCompany"
                type="date"
                placeholder="Escolha uma data"
                format="dd/MM/yyyy"
                :clearable="false"
                :editable="false"
              ></el-date-picker>
            </div>
            <small
              class="text-danger"
              v-show="dateInvoicePowerCompany.invalid"
            >
              {{ getError('dateInvoicePowerCompany') }}
            </small>
          </div>
        </div>
        <div class="form-group">
          <label>Quantidade de geladeiras</label>
          <input
            type="number"
            name="numberOfRefigerators"
            v-validate="modelValidations.numberOfRefigerators"
            v-model="model.numberOfRefigerators"
            class="form-control"
          >
          <small
            class="text-danger"
            v-show="numberOfRefigerators.invalid"
          >
            {{ getError('numberOfRefigerators') }}
          </small>
        </div>
        <div class="form-group">
          <label>Descrição do produto</label>
          <input
            type="text"
            name="description"
            v-validate="modelValidations.description"
            v-model="model.description"
            class="form-control"
          >
          <small
            class="text-danger"
            v-show="description.invalid"
          >
            {{ getError('description') }}
          </small>
        </div>
      </div>
      <div class="card-footer text-right">
        <button
          v-if="$can('stock.create|stock.edit')"
          :disabled="saving"
          type="submit"
          @click.prevent="validate"
          class="btn btn-fill btn-success btn-wd"
        >Salvar
        </button>
      </div>
    </form>

  </div>
</div>
</template>
<script>
import { DatePicker } from 'element-ui'
import { mapFields } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      indexPath: { name: 'stock.index' },
      entityName: 'Estoque',
      saving: false
    }
  },
  computed: {
    ...mapFields(['eventId', 'manufacturerId', 'invoice', 'dateInvoice', 'invoicePowerCompany', 'dateInvoicePowerCompany', 'numberOfRefigerators', 'description']),
    ...mapGetters('stocks', {
      model: 'stock',
      modelValidations: 'validations',
      loading: 'loading'
    }),
    ...mapGetters('manufacturers', {
      manufacturers: 'manufacturers'
    }),
    ...mapGetters('events', {
      events: 'events'
    }),
    id () {
      return this.$route.params.id
    },
    editing () {
      return this.id !== undefined
    },
    title () {
      return this.editing ? `Editar ${this.entityName}` : `Novo ${this.entityName}`
    }
  },
  created () {
    if (this.editing) {
      this.fetchOne(this.id)
    } else {
      this.resetOne()
    }
    this.fetchAllManufecturers()
  },
  methods: {
    ...mapActions('stocks', ['fetchOne', 'resetOne', 'insert', 'update']),
    ...mapActions('events', {
      fetchEvents: 'fetchAll'
    }),
    ...mapActions('manufacturers', {
      fetchAllManufecturers: 'fetchAll'
    }),
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.saving = true
      this.$validator.validateAll()
        .then(isValid => {
          if (isValid) {
            let doc = Object.assign({}, this.model)
            doc.collection = 'stocks'
            if (this.editing) {
              return this.update(doc)
                .then(result => {
                  this.$notify({
                    message: 'Registro editado com sucesso.',
                    type: 'success'
                  })
                  this.$router.push({ name: 'stock.index' })
                })
                .catch(err => console.log(err))
            }
            return this.insert(doc)
              .then(result => {
                this.$notify({
                  message: 'Registro criado com sucesso.',
                  type: 'success'
                })
                this.$router.push({ name: 'stock.index' })
              })
              .catch(err => console.log(err))
          }
          this.saving = false
        })
        .catch(err => {
          console.log(err)
          this.saving = false
        })
    }
  },
  mounted () {
    this.fetchEvents({
      where: [{ status: 1 }]
    })
  }
}
</script>
<style>
  .stock-form .el-select {
    width: 100%;
    /* margin-bottom: 30px; */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Stock/StockForm.vue